import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { LayoutDashboard, FolderKanban, Users, Settings, ChevronLeft, ChevronRight, Microscope } from 'lucide-react';
import { useParams, Link } from 'react-router-dom';

const LeftNav = ({ expanded, onToggle }) => {
  // Get current path to determine active item
  const currentPath = window.location.pathname;
  const { tenantDomain } = useParams();
  const navItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: `/${tenantDomain}/home` },
    { icon: Microscope, label: 'Best Allele', path: `/${tenantDomain}/best-allele` },
    { icon: Users, label: 'Users', path: `/${tenantDomain}/users` },
    { icon: Settings, label: 'Settings', path: `/${tenantDomain}/settings` }
  ];

  return (
    <div 
      className={`position-fixed h-100 border-end transition-width ${expanded ? 'w-250' : 'w-60'}`}
      style={{ 
        backgroundColor: '#f8faf8', // Slightly different shade for contrast
        top: 0,
        left: 0,
        zIndex: 1020,
        transition: 'width 0.3s ease'
      }}
    >
      <Button
        variant="light"
        size="sm"
        className="position-absolute border shadow-sm"
        style={{
          right: '-16px',
          top: '70px',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1
        }}
        onClick={onToggle}
      >
        {expanded ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
      </Button>

      <div style={{ paddingTop: '56px' }}>
        <Nav className="flex-column py-2">
          {navItems.map(({ icon: Icon, label, path }) => (
            <Nav.Link 
              key={label}
              as={Link}
              to={path}
              className={`nav-item-link d-flex align-items-center gap-3 px-3 py-2 ${
                currentPath === path ? 'active' : ''
              }`}
            >
              <Icon 
                size={20} 
                className={currentPath === path ? 'text-success' : 'text-gray-600'} 
              />
              <span className={`${expanded ? 'd-inline' : 'd-none'}`}>{label}</span>
            </Nav.Link>
          ))}
        </Nav>
      </div>
    </div>
  );
};

export default LeftNav;